import { render, staticRenderFns } from "./ModalDeleteWaste.vue?vue&type=template&id=0ad4c640&"
import script from "./ModalDeleteWaste.vue?vue&type=script&lang=js&"
export * from "./ModalDeleteWaste.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports